import { render, staticRenderFns } from "./ReaderchartTest.vue?vue&type=template&id=f97c58dc&"
import script from "./ReaderchartTest.vue?vue&type=script&lang=js&"
export * from "./ReaderchartTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports